// controllers/useLobbyListController.js
import { useEffect, useState } from 'react';
import axios from 'axios';
import { getPersistentUserId } from '@api/userService.js';
import { io } from 'socket.io-client';
import { useNavigate } from 'react-router-dom';

export function useLobbyListController() {
    const [lobbies, setLobbies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [name, setName] = useState('');
    const [showNameDialog, setShowNameDialog] = useState(false);
    const [selectedLobby, setSelectedLobby] = useState(null);
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetchLobbies();
    }, []);

    const fetchLobbies = async () => {
        try {
            setLoading(true);
            const response = await axios.get('/api/lobbies');
            setLobbies(response.data.lobbies);
        } catch (err) {
            setError('Lobbys konnten nicht geladen werden.');
        } finally {
            setLoading(false);
        }
    };

    const handleJoinLobby = (lobby) => {
        setSelectedLobby(lobby);
        setShowNameDialog(true);
        if (!lobby.isPrivate) setPassword('');
    };

    const handleNameSubmit = (e) => {
        e.preventDefault();
        if (!name.trim()) return;

        const socket = io('/lobby');
        const persistentId = getPersistentUserId();

        socket.emit('joinLobby', {
            lobbyCode: selectedLobby.code,
            user: { name, persistentId },
            password: selectedLobby.isPrivate ? password : null,
        }, (response) => {
            if (response.success) {
                navigate(`/lobby/${selectedLobby.code}`);
            } else {
                setError(response.message || 'Fehler beim Beitreten');
                socket.disconnect();
            }
        });

        setShowNameDialog(false);
        setName('');
        setPassword('');
    };

    return {
        lobbies, loading, error,
        name, setName,
        password, setPassword,
        showNameDialog, setShowNameDialog,
        selectedLobby, handleJoinLobby, handleNameSubmit,
        fetchLobbies
    };
}
